import script from "./activeBrands.vue?vue&type=script&setup=true&name=tableModal&lang=js"
export * from "./activeBrands.vue?vue&type=script&setup=true&name=tableModal&lang=js"

import "./activeBrands.vue?vue&type=style&index=0&id=7ba57538&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba57538"]])

export default __exports__